import React, { useState, useEffect } from 'react';
import ConsultazioneRicerca from './ConsultazioneRicerca';
import ConsultazioneVistaProdotto from './ConsultazioneVistaProdotto';

function Consultazione() {

    const [prodotto, setProdotto] = useState(false);

   

    /* useEffect(() => {
      if (!token) {
          console.warn("sto aspettando un token")
          return;
      }
      fetchOrdini()
    }, [token]); */

    return prodotto ? 
          <ConsultazioneVistaProdotto prodotto={prodotto} setProdotto={setProdotto} /> 
        : <ConsultazioneRicerca prodotto={prodotto} setProdotto={setProdotto} />

}

export default Consultazione;